import firebase from 'firebase/app';
const CONFIG = {
  apiKey: 'AIzaSyDKnc-XNFiAfwjtNQRuY9jFaMuh9G6Fe7A',
  authDomain: 'jet-foiler.firebaseapp.com',
  databaseURL: 'https://jet-foiler.firebaseio.com',
  projectId: 'jet-foiler',
  storageBucket: 'jet-foiler.appspot.com',
  messagingSenderId: '672002494783'
};

const firebaseApp: firebase.app.App = firebase.initializeApp(CONFIG);
export default firebaseApp;
export { firebase };
